// The reveal beat's timeline, computed from a reveal.config.js preset alone
// (pure). All times are ms from the beat's start.
//
//   attack -> (clash) -> missile launch -> crest -> IMPACT
//   impact: flash; hit-stop (scene frozen); then blast (explosion flipbook,
//   sparks, debris thrown, crater rings start); then settle (smoke, debris
//   landing, glow and haze fading). Shake from the end of the hit-stop.
export function revealPlan(cfg, { maxRing = 3 } = {}) {
    const attackStart = cfg.leadMs
    const clash = cfg.clash.enabled
    const meetAt = clash ? attackStart + cfg.clash.riseMs : attackStart
    const defenderStart = clash ? attackStart + cfg.clash.responseDelayMs : attackStart
    const missileStart = clash ? meetAt + cfg.clash.gapMs : attackStart
    const crestAt = missileStart + cfg.missile.riseMs
    const impactAt = crestAt + cfg.missile.fallMs
    const anticipation = cfg.anticipation.enabled
        ? { stretchStart: impactAt - cfg.anticipation.stretchMs }
        : null
    const hitStopEnd = impactAt + cfg.hitStopMs
    const flashEnd = impactAt + (cfg.flash.enabled ? cfg.flash.ms : 0)
    const blastStart = Math.max(hitStopEnd, cfg.blast.after === 'flash' ? flashEnd : impactAt)
    const blastEnd = blastStart + cfg.blast.ms
    const settleEnd = blastEnd + cfg.settleMs
    const explosionEnd = cfg.explosion.enabled ? blastStart + explosionClipMs(cfg.explosion) : blastStart
    const smokeStart = blastEnd - cfg.smoke.leadMs
    const ringsDone = blastStart + maxRing * cfg.crater.ringDelayMs + cfg.crater.cellGrowMs
    const particlesDone = blastStart + cfg.sparks.emitMs + cfg.sparks.lifeMs[1]
    const shakeEnd = hitStopEnd + (cfg.shake.enabled ? cfg.shake.durationMs : 0)
    const glowEnd = blastEnd + cfg.bloom.decayMs
    const hazeEnd = blastStart + cfg.distortion.durationMs
    const settled = Math.max(settleEnd, ringsDone, particlesDone, shakeEnd, glowEnd, hazeEnd)
    return {
        attackStart, defenderStart, meetAt, missileStart, crestAt, impactAt, anticipation, hitStopEnd, flashEnd,
        blastStart, blastEnd, explosionEnd, smokeStart, settleEnd, ringsDone, particlesDone, shakeEnd, glowEnd, hazeEnd,
        end: settled + cfg.holdMs,
    }
}

// Sheet frames a flipbook clip plays: frames [a, b] inclusive, every `step`.
export function clipFrames({ frames: [a, b], step = 1 }) {
    const out = []
    for (let i = a; i <= b; i += step) out.push(i)
    return out
}
export const explosionClipMs = ex => (clipFrames(ex).length * 1000) / ex.fps
